module.exports = __webpack_public_path__ + "img/speaker-4-4.ee7c46c4.jpg";